export const domains = {
    "sudani": "https://sudani.nasna.tv/login",
    "mtn": "https://mtn.nasna.tv/login",
    "zain": "https://zain.nasna.tv/login",
    "mobily-ksa": "https://mobily.nasna.tv/auth/mobily/subscribe",
    "stc-ksa": "https://stc.nasna.tv/auth/subscribe",
    "etisalat-uae": "https://ae.nasna.tv",
    "stripe": "auth.profile",
    "du-uae": "https://du.nasna.tv"
};


